import http from "./httpService";

class EducatorsGuideService {
  async getEducatorsGuideBySlug(slug) {
    return http.get(`/educator-guide/slug/${slug}`);
  }

  async getEducatorsGuideById(id, locale) {
    return http.get(`/educator-guide/airtable/${id}`, { params: { locale } });
  }

  async getUserEducatorsGuideById(id) {
    return http.get(`/educator-guide/airtable-by-school/${id}`);
  }
}

export default new EducatorsGuideService();
